<template>
	<div class="page-banner page-content">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">供应商管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>供应商管理</el-breadcrumb-item>
							<el-breadcrumb-item>统计信息</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="content-body div-statis-box">
					<div class="chart-box">
						<!-- 销量 -->
						<div class="chart-box-item">
							<v-chart class="v-chart" :option.sync="order_day_count_obj.data" />
							<div class="form-box">
								<el-form :inline="true" :model="order_day_count_obj.form" class="demo-form-inline"
									@submit.native.prevent>
									<el-form-item style="margin-bottom: 0;">
										<el-select v-model="order_day_count_obj.form.time" size="small"
											placeholder="请选择" style="width: 80px;" @change="changeDateOrderDataCount()">
											<el-option v-for="item in init_data.time_list" :key="item.id"
												:label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-form>
							</div>
						</div>
						<!-- 产品占比 -->
						<div class="chart-box-item">
							<v-chart class="v-chart" :option="order_scale_obj.data" />
							<div class="form-box">
								<el-form :inline="true" :model="order_scale_obj.form" class="demo-form-inline"
									@submit.native.prevent>
									<el-form-item style="margin-bottom: 0;">
										<el-select v-model="order_scale_obj.form.time" size="small"
											placeholder="请选择" style="width: 80px;" @change="changeDateOrderScaleDataCount()">
											<el-option v-for="item in init_data.time_list" :key="item.id"
												:label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-form>
							</div>
						</div>
						<!-- 销售量排行 -->
						<v-chart class="v-chart" :option="order_count_obj.data" />
					</div>
					<div class="log-box">
						<div class="hd" style="margin-bottom: 0">
							<h4>商品销售记录</h4>
						</div>
						<div class="bd">
							<el-table ref="multipleTable" :data="table_log.list" height="500px"
								v-loading="table_log.loading" tooltip-effect="dark"
								style="width: 100%;text-align: center;">
								<el-table-column prop="finish_date" align="center" label="消费时间" min-width="140">
								</el-table-column>
								<el-table-column prop="product_name" align="center" label="商品名称" min-width="120">
								</el-table-column>
								<el-table-column prop="product_count" align="center" label="数量" min-width="90">
								</el-table-column>
								<el-table-column prop="status_name" align="center" label="状态" min-width="80">
									<template slot-scope="scope">
										<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		use
	} from "echarts/core";
	import {
		CanvasRenderer
	} from "echarts/renderers";
	import {
		PieChart,
		LineChart,
		BarChart,
	} from "echarts/charts";
	import {
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		GridComponent
	} from "echarts/components";
	import VChart, {
		THEME_KEY
	} from "vue-echarts";

	use([
		CanvasRenderer,
		PieChart,
		LineChart,
		BarChart,
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		GridComponent
	]);

	export default {
		name: "HelloWorld",
		components: {
			VChart
		},
		provide: {
			[THEME_KEY]: ""
		},
		data() {
			return {
				init_data: {
					time_list: [{
						id: 7,
						name: '近7天'
					}, {
						id: 15,
						name: '近15天'
					}, {
						id: 30,
						name: '近30天'
					}],
				},
				// 销量统计
				order_day_count_obj: {
					loading: false,
					form: {
						time: 7
					},
					data: {
						title: {
							left: 'center',
							text: '产品日销量'
						},
						xAxis: {
							data: []
						},
						yAxis: {},
						series: [{
							data: [],
							type: 'line',
							smooth: true
						}],
						subtitle: "单位：单/天",
						unit: '单'
					}
				},
				// 产品销售占比
				order_scale_obj: {
					loading: false,
					form: {
						time: 7
					},
					data: {
						title: {
							left: 'center',
							text: '各产品销量占比'
						},
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							left: '5%'
						},
						series: [{
							name: 'Access From',
							type: 'pie',
							radius: ['40%', '70%'],
							avoidLabelOverlap: false,
							itemStyle: {
								borderRadius: 10,
								borderColor: '#fff',
								borderWidth: 2
							},
							label: {
								show: false,
								position: 'center'
							},
							emphasis: {
								label: {
									show: true,
									fontSize: '40',
									fontWeight: 'bold'
								}
							},
							labelLine: {
								show: false
							},
							data: []
						}]
					}
				},
				// 各产品总销量
				order_count_obj: {
					loading: false,
					form: {
						time: 7
					},
					data: {
						title: {
							left: 'center',
							text: '各产品总销量'
						},
						xAxis: {
							type: 'category',
							data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: [120, 200, 150, 80, 70, 110, 130],
							type: 'bar',
							showBackground: true,
							backgroundStyle: {
								color: 'rgba(180, 180, 180, 0.2)'
							}
						}]
					}
				},
				// 销售商品日志列表
				table_log: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 50,
						total: 50
					}
				}
			}
		},
		created() {
			this.getLogData();
			this.getSupplierProductDayStatis();
			this.getSupplierProductScaleStatis();
			this.getSupplierProductStatis();
		},
		methods: {
			// 获取供应商产品日销量统计数据
			getSupplierProductDayStatis() {
				var _this = this;
				var params = {
					lately_day: _this.order_day_count_obj.form.time,
				};
				this.$client.get('/adminapi/statis/supplierproductdaystatis', params, function(res, message) {
					_this.order_day_count_obj.data.xAxis.data = res.xaxis;
					_this.order_day_count_obj.data.series[0].data = res.series_data;
				}, function(res) {

				});
			},
			// 修改日销售下拉时间
			changeDateOrderDataCount(){
				this.getSupplierProductDayStatis();
			},
			// 获取供应商各产品销售占比
			getSupplierProductScaleStatis() {
				var _this = this;
				var params = {
					lately_day: _this.order_scale_obj.form.time,
				};
				this.$client.get('/adminapi/statis/supplierproductscalestatis', params, function(res, message) {
					_this.order_scale_obj.data.series[0].data = res.series_data;
				}, function(res) {
					
				});
			},
			// 修改日销售下拉时间
			changeDateOrderScaleDataCount(){
				this.getSupplierProductScaleStatis();
			},
			// 获取供应商产品日销量统计数据
			getSupplierProductStatis() {
				var _this = this;
				var params = {
					// lately_day: _this.order_day_count_obj.form.time,
				};
				this.$client.get('/adminapi/statis/supplierproductstatis', params, function(res, message) {
					_this.order_count_obj.data.xAxis.data = res.xaxis;
					_this.order_count_obj.data.series[0].data = res.series_data;
				}, function(res) {
			
				});
			},
			// 修改日销售下拉时间
			changeDateOrderCount(){
				this.getSupplierProductStatis();
			},
			// 销售记录列表
			getLogData() {
				var _this = this;
				_this.table_log.loading = true;
				var params = {};
				params.p = _this.table_log.page_info.page;
				params.pageSize = _this.table_log.page_info.pageSize;
				this.$client.get('/adminapi/statis/getsupplierItemlist', params, function(res, message) {
					_this.table_log.list = res.list;
					_this.table_log.loading = false;
					_this.table_log.page_info = res.pager;
				}, function(res) {
					_this.table_log.loading = false;
				});
			}
		}
	};
</script>

<style scoped>
	.div-statis-box {
		display: flex;
		flex-flow: row nowrap;
	}

	.chart-box {
		display: flex;
		flex-flow: column nowrap;
		justify-content: flex-start;
		width: 40vw;
	}

	.log-box {
		width: 40vw;
	}

	.v-chart {
		height: 400px;
		width: 100%;
		margin-top: 20px;
	}

	.chart-box-item {
		position: relative;
	}

	.form-box {
		position: absolute;
		right: 50px;
		top: 10px;
	}
</style>

<style>
	body {
		margin: 0;
	}
</style>
